import { APP, WS_DATA } from './app.constants';

export const SITES = `${APP}_sites`;

export const SET_SELECTED_SITES = `${SITES}/SET_SELECTED_SITES`;

export const WS_DATA_SITE = `${WS_DATA}/site`;
export const WS_DATA_SITES = `${WS_DATA}/sites`;